import React from 'react';
import Window from '../os/Window';
import useInitialWindowSize from '../../hooks/useInitialWindowSize';

const CV_PDF_URL = '/papers/Filips_Juzilins_CV_F.pdf';

const PdfViewer: React.FC<WindowAppProps> = (props) => {
    const { initWidth, initHeight } = useInitialWindowSize({ margin: 80 });

    return (
        <Window
            top={48}
            left={80}
            width={Math.min(initWidth, 720)}
            height={Math.min(initHeight, 900)}
            windowTitle="Filips Juzilins - CV"
            windowBarIcon="pdfIcon"
            closeWindow={props.onClose}
            onInteract={props.onInteract}
            minimizeWindow={props.onMinimize}
        >
            <div style={styles.container}>
                <iframe
                    title="CV"
                    src={CV_PDF_URL}
                    style={styles.iframe}
                />
            </div>
        </Window>
    );
};

const styles: StyleSheetCSS = {
    container: {
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        backgroundColor: '#2c2c2e',
    },
    iframe: {
        width: '100%',
        height: '100%',
        border: 'none',
        display: 'block',
    },
};

export default PdfViewer;
